import { TextField } from '@mui/material';

const WidgetFormTextField = ({ label, ...props }) => {
    return (
        <TextField
            fullWidth
            size="small"
            margin="dense"
            label={label}
            {...props}
        />
    );
};

export default WidgetFormTextField;
